// upstack_api's Engagements::Discovery refuses anything past these, so the inputs stop there first.
export const DISCOVERY_TEXT_LIMIT = 10000;
export const DISCOVERY_CHOICE_LIMIT = 200;
export const DISCOVERY_ADDED_CHOICES_LIMIT = 50;
export const DISCOVERY_NUMBER_LIMIT = 2147483647;
